<template>
    <div class="p-2 text-2xl inline  cursor-pointer" @click="goHome()">
        <span class="icon-home"></span>
    </div>
</template>

<script>
export default {
    name: "BtnHome",
    methods: {
        goHome() {
            let self = this;

            //this.trackEvent("Menu:Home", {});
            this.trackEvent("cta_click:Home",  {});

            $eventbus.$emit('close:all');
            self.$router.push({
                name: 'catalogues'
            }).catch(() => { });
            console.log('go home');
        }
    }
}
</script>

<style scoped lang="scss"></style>
